import { ConfigContext } from "@/core/contexts/ConfigContext";
import { TaskData } from "@/core/types/types";
import { useContext, useEffect } from "react";
import trackPageViewEvents from "@/core/utils/trackPageViewEvents";

const useAnalyticsPageView = (currentStep: TaskData | null) => {
  const initialisationConfig = useContext(ConfigContext);
  const definitionName = initialisationConfig?.definitionName;
  const domain: string = `${initialisationConfig?.brandId}.${initialisationConfig?.domain}`;
  const processId: string | undefined = initialisationConfig?.processId;

  useEffect(() => {
    if (!currentStep) return;

    const {
      extensionProperties: { stepTitle, eventsToExpose },
    } = currentStep;

    if (stepTitle) {
      const eventsAsArray = eventsToExpose?.split(",");
      trackPageViewEvents({
        stepTitle,
        definitionName,
        domain,
        processId,
        eventsToExpose: eventsAsArray,
      });
    }
  }, [currentStep?.task?.id]);
};

export { useAnalyticsPageView };
